import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { HomepageOverviewComponent } from "./homepage-overview.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";

const routes: Routes = [
  {
    path: "",
    component: HomepageOverviewComponent,
    data: {
      title: "Homepage Overview",
      breadcrumb: "Homepage Overview",
    },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes), FormsModule, ReactiveFormsModule],
  declarations: [],
  exports: [RouterModule],
})
export class HomepageoverviewRoutingModule {}
